<template>
      <div
        class="modal trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >IMPORT DO NOT ARB FILE</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- Chart -->
              <div class="chart">
                <img src="@/assets/img/vector/upload-csv01.png" class="w-25 img-fluid" alt="Import" />
                <h4>
                  <i class="fas fa-info-circle"></i> INFORMATION
                </h4>
                <p class="modalp">Please select csv file for upload.</p>
                <progress v-if="uploadPercentage && !success" max="100" :value.prop="uploadPercentage"></progress><br>
                <label for="file-upload" class="custom-file-upload btn btn-primary my-2">
                  UPLOAD
                  <i v-if="!loading" class="fas fa-cloud-upload-alt"></i>
                  <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                </label>
                <input id="file-upload" type="file" accept=".csv"  @change="upload('input')" />
                <div v-if="error" class="alert alert-danger" role="alert">
                  <i class="fas fa-exclamation-triangle"></i>
                  File upload failed. Please try again
                </div>
                <div  v-if="success" class="import-success">
                  <h4 class="text-success"><i class="fas fa-check"></i> IMPORT SUCCESS. FILE IS UNDER PROCESS </h4>
                  <!-- <div class="import-success">
                        <div class="summary-wrap">
                            <div class="opn-wrap">
                            <a href="#">
                                Offerings 
                                <router-link to="/ims/ims-offering/alloffering">                       
                                  <button @click="$emit('close')" type="submit" class="btn btn-primary my-2">GO <i aria-hidden="true" class="fa fa-arrow-circle-right"></i></button>
                                </router-link>
                            </a>
                            </div>
                        </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>

    <script>
    import authService from "@/authService";
    // import config from "@/config";
    import AWS from 'aws-sdk/global';
    import config from "@/config";
    export default {
        name: 'offeringImportmodal',
        components :{
            
        },
        data() {
            return {
                loading : false,
                error : null,
                errors: [],
                success : false,
                uploadPercentage: 0,
            };
        },
        methods: {
         uploadToS3: function() {
            this.error = false;
            this.success = false;
            const configOption = {
                onUploadProgress: progressEvent => {
                  //console.log(progressEvent.loaded);
                  this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))
                },
                // headers: { 'org-token' : authService.getOrgToken(),'Content-Type': 'multipart/form-data' }
            }
            var files = document.getElementById("file-upload").files;
            if (!files.length) {
              return alert("Please choose a file to upload first.");
            }
            let formData = new FormData();
            var fileToUpload = files[0];
            formData.append('file', fileToUpload);
            this.loading = true;
            this.$http
            .post(
              config.baseUrlBidSide +
                "/file/s3-upload?title=Testtitle&description=Testdescription&folder=offering",
                formData,
                configOption
                
            )
            .then((result) => {
              this.offeringFileUpload(result.data.key) 
            })
            .catch(e => {
                console.log("Error", e);
                this.loading = false;
                this.error = true;
                this.success = false;
              });

          },
          offeringFileUpload(filePath){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            let data  =  {
              "key": filePath,
              "cognitoSub" : authService.getUser().cognitoSub,
              "isMuni" : localStorage.getItem("ARBSFEEDTYPE") ? (localStorage.getItem("ARBSFEEDTYPE") == "MUNIS" ? true : false) : true
            }
            this.$http
            .post(
              config.baseUrlAutoBidder +
                "/arbs-feed/do-not-arb-file",
               data,
               auth
            )
            .then(() => {
              this.loading = false;
              this.error = false;
              this.success = true;
                  
              
            })
            .catch(e => {
                console.log("Error", e);
                this.loading = false;
                this.error = true;
                this.success = false;
              });
          },
          upload: function(albumName) {
              this.error = false;
              this.success = false;
              var s3 = new AWS.S3({
                apiVersion: "2006-03-01",
                params: { Bucket: "imsfileupload"}
              });
              console.log(s3);
              var files = document.getElementById("file-upload").files;
              if (!files.length) {
                return alert("Please choose a file to upload first.");
              }
              var file = files[0];
              var fileName = file.name;
              var albumPhotosKey = encodeURIComponent(albumName) + "/";
              var UUID = this.uuidv4();
              console.log(UUID);
              var photoKey = albumPhotosKey + fileName;
              var albumBucketName = config.albumBucketNameIms+"/donotarb/"+UUID;
              console.log(photoKey);
              this.loading = true;
              // Use S3 ManagedUpload class as it supports multipart uploads
              var self = this;
              s3.upload(
                { Key: file.name, Bucket: albumBucketName, Body: file, ACL: "private" },
                function(err, data) {
                  this.fileuploading = false;
                  if (err) {
                    console.log(err, "there was an error uploading your file");
                  } else {
                    this.locationUrl = data.Location;
                    this.serviceBucketName = data.Bucket;
                    this.s3response = data;
                    
                    self.offeringFileUpload("donotarb/"+UUID+"/"+file.name)
                  }
                }
              );
          }
        },
        created: function() {
          this.user = this.$cognitoAuth.getCurrentUser();
          this.$cognitoAuth.getIdToken((err, result) => {
            if (err) {
              console.log("accessToken is not found", err);
            } else {
              this.accessToken = result;
            }
          });
          const userPoolLoginKey = config.userPoolLoginKey;
          const logins = {};
          logins[userPoolLoginKey] = this.accessToken;
          AWS.config.region = config.region;
          const cognitoParams = {
            IdentityPoolId: config.IdentityPoolIdFileUpload,
            Logins: logins
          };
          let cognitoidentity = new AWS.CognitoIdentity();
          cognitoidentity.getId(cognitoParams, function(err, data) {
            if (err) {
              console.log(err);
            } else {
              console.log(data.IdentityId);
              let bucketRegion = AWS.config.region;
              AWS.config.update({
                region: bucketRegion,
                credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
              });
            }
          });
        }
    };
    </script>